import script from "./ContinueReading.vue?vue&type=script&setup=true&lang=js"
export * from "./ContinueReading.vue?vue&type=script&setup=true&lang=js"

import "./ContinueReading.vue?vue&type=style&index=0&id=21bceae8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21bceae8"]])

export default __exports__